<template>
  <form @submit.prevent="submit" :class="errorClass" autocomplete="off">
    <rp-select
      class="role"
      v-model="resource.role"
      placeholder="Select a role"
      @input="touch('role')"
      isRequired
      :error="roleError">
      <option v-for="(option, index) in roles" :value="option.value" :key="index">{{option.key}}</option>
    </rp-select>

    <rp-textinput
      v-model="resource.email"
      placeholder="email"
      :error="emailError"
      isRequired
      @input="touch('email')"/>

    <rp-select
      class="gender"
      v-model="resource.gender"
      placeholder="Gender"
      @input="touch('gender')"
      isRequired
      :error="genderError">
      <option v-for="(gender, index) in genders" :value="gender.value" :key="index">{{gender.label}}</option>
    </rp-select>

    <rp-select
      class="locales"
      v-model="resource.locale_id"
      placeholder="Language spoken"
      @input="touch('locale_id')"
      isRequired
      :error="locale_idError">
      <option v-for="(option,index) in locales" :value="option.value" :key="index">
        {{option.key}}
      </option>
    </rp-select>

    <rp-textinput
      v-model="resource.first_name"
      placeholder="First Name"
      isRequired
      :error="first_nameError"
      @input="touch('first_name')"/>

    <rp-textinput
      v-model="resource.last_name"
      placeholder="Last Name"
      isRequired
      :error="last_nameError"
      @input="touch('last_name')"/>

    <rp-dropdown
      v-if="distributorRoleIsSelected()"
      v-model="resource.countriesSelected"
      :data-model="countries"
      objectLabel="name"
      placeholder="Countries"
      isRequired
      multiselect
      scrollable
      formStyle />

    <rp-dropdown
      v-if="hospitalAdminRoleIsSelected()"
      v-model="resource.hospitalsSelected"
      :data-model="hospitals"
      objectLabel="name"
      placeholder="Hospitals"
      isRequired
      multiselect
      scrollable
      formStyle />

    <rp-password
      v-model="resource.password"
      placeholder="Password"
      isRequired
      @input="touch('password')"/>

    <rp-password
      v-model="resource.password_confirmation"
      placeholder="Confirm Password"
      isRequired
      @input="touch('password_confirmation')"/>

    <rp-textinput
      class="salutation"
      v-model="resource.salutation"
      placeholder="Title"
      v-if="surgeonRoleIsSelected()"/>

    <rp-textinput
      class="speciality"
      v-model="resource.speciality"
      placeholder="Speciality"
      v-if="surgeonRoleIsSelected()"/>

    <h4>You must agree to the following important terms of use before registering new user with RayPRO:</h4>

    <rp-checkbox
      v-model="resource.endUserPrivacy"
      link="http://www.rayner.com/raypro/privacy"
      label="End-user Privacy Policy"
      @input="touch('endUserPrivacy')"
      :error="endUserPrivacyError"/>

    <rp-checkbox
      v-model="resource.endUserLicense"
      link="http://www.rayner.com/raypro/terms"
      label="End-user License Agreement & Data Sharing Agreement"
      @input="touch('endUserLicense')"
      :error="endUserLicenseError"/>

    <rp-button :disabled="isInvalid" type="primary">Submit</rp-button>
  </form>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {email, required, sameAs, requiredIf} from 'vuelidate/lib/validators'
  
  import {errorMessages} from '../../../api/error_messages'

  import form from '../../../mixins/form'

  import Button from '../../../components/ui/inputs/Button'
  import Password from '../../../components/ui/inputs/PasswordInput'
  import TextInput from '../../../components/ui/inputs/TextInput'
  import DatePicker from '../../../components/ui/inputs/DatePicker'
  import Select from '../../../components/ui/inputs/StyledSelect'
  import Checkbox from '../../../components/ui/inputs/Checkbox'
  import Dropdown from '../../../components/ui/inputs/dropdown/Dropdown'

  export default {
    name: 'UserForm',
    mixins: [validationMixin, form],
    props: {
      roles: Array,
      locales: Array,
      genders: Array,
      countries: Array,
      hospitals: Array,
      surgeonRoleIsSelected: { type: Function },
      distributorRoleIsSelected: { type: Function },
      hospitalAdminRoleIsSelected: { type: Function }
    },

    components: {
      'rp-button': Button,
      'rp-password': Password,
      'rp-textinput': TextInput,
      'rp-datepicker': DatePicker,
      'rp-select': Select,
      'rp-checkbox': Checkbox,
      'rp-dropdown': Dropdown
    },

    computed: {
      ...errorMessages([
        'email',
        'gender',
        'first_name',
        'last_name',
        'locale_id',
        'role',
        'endUserPrivacy',
        'endUserLicense'
      ])
    },

    validations: {
      resource: {
        email: {required, email},
        password: {required},
        password_confirmation: {sameAs: sameAs('password')},
        gender: {required},
        first_name: {required},
        last_name: {required},
        role: {required},
        locale_id: {required},
        countriesSelected: {
          required: requiredIf(function() {
            return this.distributorRoleIsSelected()
          })
        },
        hospitalsSelected: {
          required: requiredIf(function() {
            return this.hospitalAdminRoleIsSelected()
          })
        },
        endUserPrivacy: {terms: sameAs(() => {return true})},
        endUserLicense: {terms: sameAs(() => {return true})}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// ../raypro_ui/src/components/ui/forms/User.vue